<header class="public-app-header">
  <div class="public-app-header__inner site-content-container">
    <a
      class="public-app-header__brand"
      [routerLink]="homeRoute"
      aria-label="CitizeX home"
      (click)="scrollToTop()"
    >
      <img src="../../../../assets/images/logo-text.png" alt="CitizeX" />
    </a>

    <nav class="public-app-header__nav" aria-label="Primary navigation">
      <a
        routerLink="/events"
        routerLinkActive="is-active"
        ariaCurrentWhenActive="page"
        >Events</a
      >
      <a
        routerLink="/representatives"
        routerLinkActive="is-active"
        ariaCurrentWhenActive="page"
      >
        Representatives
      </a>
      <a
        routerLink="/posts"
        routerLinkActive="is-active"
        ariaCurrentWhenActive="page"
        >Posts</a
      >
      <a
        routerLink="/polls"
        routerLinkActive="is-active"
        ariaCurrentWhenActive="page"
        >Polls</a
      >
    </nav>

    <nav class="public-app-header__actions" aria-label="Account navigation">
      <ng-container *ngIf="isAuthenticated; else desktopGuestActions">
        <span class="public-app-header__account-state">
          <small>Signed in as</small>
          <strong>{{ accountDisplayName }}</strong>
        </span>
        <button
          type="button"
          class="public-app-header__logout"
          (click)="logOut()"
        >
          Log out
        </button>
      </ng-container>

      <ng-template #desktopGuestActions>
        <a
          class="public-app-header__action-link public-app-header__demo"
          routerLink="/request-demo"
          routerLinkActive="is-active"
          ariaCurrentWhenActive="page"
        >
          Request Demo
        </a>
        <span class="public-app-header__divider" aria-hidden="true"></span>
        <a
          class="public-app-header__action-link"
          routerLink="/login"
          routerLinkActive="is-active"
          ariaCurrentWhenActive="page"
        >
          Sign In
        </a>
        <a
          class="public-app-header__signup"
          routerLink="/signup"
          routerLinkActive="is-active"
          ariaCurrentWhenActive="page"
        >
          Sign Up
        </a>
      </ng-template>
    </nav>
  </div>
</header>

<header class="public-mobile-header">
  <div class="public-mobile-header__bar site-content-container">
    <a
      class="public-mobile-header__brand"
      [routerLink]="homeRoute"
      aria-label="CitizeX home"
      (click)="scrollToTop()"
    >
      <img src="../../../../assets/images/logo-text.png" alt="CitizeX" />
    </a>

    <button
      type="button"
      class="menu-toggle"
      (click)="toggleMobileMenu($event)"
      [attr.aria-expanded]="isMobileMenuOpen"
      aria-controls="public-mobile-menu"
      [attr.aria-label]="
        isMobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'
      "
    >
      <span
        [class]="
          isMobileMenuOpen ? 'cx-mobile-close-icon' : 'cx-mobile-menu-icon'
        "
        aria-hidden="true"
      ></span>
    </button>
  </div>

  <nav
    id="public-mobile-menu"
    class="public-mobile-menu"
    [class.show]="isMobileMenuOpen"
    [attr.aria-hidden]="!isMobileMenuOpen"
    [attr.inert]="!isMobileMenuOpen ? '' : null"
    aria-label="Mobile navigation"
  >
    <a
      routerLink="/events"
      routerLinkActive="is-active"
      ariaCurrentWhenActive="page"
      (click)="closeMobileMenu()"
    >
      Events
    </a>
    <a
      routerLink="/representatives"
      routerLinkActive="is-active"
      ariaCurrentWhenActive="page"
      (click)="closeMobileMenu()"
    >
      Representatives
    </a>
    <a
      routerLink="/posts"
      routerLinkActive="is-active"
      ariaCurrentWhenActive="page"
      (click)="closeMobileMenu()"
    >
      Posts
    </a>
    <a
      routerLink="/polls"
      routerLinkActive="is-active"
      ariaCurrentWhenActive="page"
      (click)="closeMobileMenu()"
    >
      Polls
    </a>
    <ng-container *ngIf="isAuthenticated; else mobileGuestActions">
      <div class="public-mobile-menu__account">
        <span>Signed in as</span>
        <strong>{{ accountDisplayName }}</strong>
        <small *ngIf="accountEmail && accountEmail !== accountDisplayName">
          {{ accountEmail }}
        </small>
      </div>
      <button
        type="button"
        class="public-mobile-menu__logout"
        (click)="logOut()"
      >
        Log out
      </button>
    </ng-container>

    <ng-template #mobileGuestActions>
      <a
        routerLink="/request-demo"
        routerLinkActive="is-active"
        ariaCurrentWhenActive="page"
        (click)="closeMobileMenu()"
      >
        Request Demo
      </a>
      <a
        routerLink="/login"
        routerLinkActive="is-active"
        ariaCurrentWhenActive="page"
        (click)="closeMobileMenu()"
      >
        Sign In
      </a>
      <a
        class="public-mobile-menu__signup"
        routerLink="/signup"
        routerLinkActive="is-active"
        ariaCurrentWhenActive="page"
        (click)="closeMobileMenu()"
      >
        Sign Up
      </a>
    </ng-template>
  </nav>
</header>
